import React from 'react'
import { Trans } from '@lingui/macro'
import {
  IconFaceVerified, IconSend, IconLockLocked, IconDownload
} from '@yoti/ui-kit-components-react/icons';
import IconText from '../../common/typography/IconText'
import '../WhatIsYoti.scss'

const POINTS = [
  { icon: <IconFaceVerified />, text: <Trans>Prove your identity to businesses and individuals you trust.</Trans> },
  { icon: <IconSend />, text: <Trans>Connect with verified people online.</Trans> },
  { icon: <IconLockLocked />, text: <Trans>Protect your passwords. </Trans> },
  { icon: <IconDownload />, text: <Trans><b>Join over 10 million people with the free Yoti app</b></Trans> }
]

const WhatIsYotiPoints = () => (
  <ul className="what-is-yoti__points">
    { POINTS.map(({ icon, text }, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <li key={`point-${index + 1}`}>
        <IconText icon={icon}>
          { text }
        </IconText>
      </li>
    ))}
  </ul>
)

export default WhatIsYotiPoints
